<template v-if="teacher">
<BCard>
    <BRow>
        <BCol cols="12" xl="6" class="d-flex justify-content-between flex-column" >
            <div class="d-flex justify-content-start">
                <BAvatar :text="avatarText(teacher.full_name)" size="104px" rounded />
                <div class="d-flex flex-column ml-1">
                    <div class="mb-1">
                        <h4 class="mb-0"> {{ teacher.full_name }} </h4>
                        <span class="card-text">{{ teacher.email }}</span>
                    </div>
                    <div class="d-flex flex-wrap">
                        <BButton v-if="ability.can('write', 'teacher')" :to="{ name: 'teachers-edit', params: { id: teacher.id } }" variant="primary" > {{$t('Edit')}} </BButton>
                        <BButton v-if="ability.can('delete', 'teacher')" variant="outline-danger" class="ml-1" @click="deletePopup(teacher.id, 'teachers/deleteTeacher', 'teachers')"> {{$t('Delete')}} </BButton>
                    </div>
                </div>
            </div>
        </BCol>
    </BRow>
</BCard>
</template>

<script>
import { BAvatar, BButton, BCard, BCol, BRow } from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter'
import { inject } from '@vue/composition-api';
import popups from '@/hooks/popups';
import ability from '@/libs/acl/ability'


export default {
    components: { BCard, BRow, BCol, BAvatar, BButton },
    setup(){
        const { deletePopup } = popups()
        const teacher = inject('teacher')

        return {
            deletePopup,
            avatarText,
            teacher,
            ability
        }
    }
}
</script>

<style>

</style>